import { useMemo } from 'react';
import { QueryOptions, useMutation } from 'react-query';
import moment from 'moment';
import { toastr } from 'react-redux-toastr';

import MincTransactionsService from '../../services/mincTransactionsService';

const useGenerateMincTransactionsReport = ({
  options = {},
  propertyName,
}: {
  organizationId: string,
  propertyId: string,
  propertyName?: string,
  ids: Array<string>,
  options?: QueryOptions,
}) => {
  const service = useMemo(() => new MincTransactionsService(), []);

  return useMutation(
    async (values) => {
      const timestamp = moment().format('YYYY_MM_DD_HHmmss');
      const base = propertyName
        ? propertyName.replace(/[^a-zA-Z0-9]/g, '_')
        : 'MINC_Transactions_Report';
      const fileName = `${base}_${timestamp}.xml`;
      return service.generateMincReport(
        values.organizationId,
        values.propertyId,
        values.ids,
        fileName,
      );
    },
    {
      ...options,
      onSuccess: () => {
        toastr.success(
          'Success',
          'Successfully Created MINC Transactions Report',
        );
      },
      onError: (error) => {
        toastr.error('Error', error);
      },
    },
  );
};

export default useGenerateMincTransactionsReport;
